/**
 * Mobile Detection Utilities for LOOPINO AI Platform
 * Determines when to show mobile interface vs desktop
 */

/**
 * Check if device is mobile based on screen size and user agent
 */
export const isMobile = () => {
  // Check screen width first (most reliable)
  if (typeof window !== 'undefined') {
    return window.innerWidth <= 768;
  }
  return false;
};

/**
 * Check if device is mobile by user agent (additional check)
 */
export const isMobileUserAgent = () => {
  if (typeof navigator !== 'undefined') {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }
  return false;
};

/**
 * Check if we should show mobile interface
 * Currently triggers automatically on mobile devices
 */
export const shouldShowMobileInterface = () => {
  return isMobile() || isMobileUserAgent();
};

/**
 * Get device type for analytics/logging
 */
export const getDeviceType = () => {
  if (isMobile()) return 'mobile';
  if (window.innerWidth <= 1024) return 'tablet';
  return 'desktop';
};

/**
 * Check if device supports touch
 */
export const isTouchDevice = () => {
  if (typeof window !== 'undefined') {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  }
  return false;
};

/**
 * Get viewport dimensions for mobile layout calculations
 */
export const getViewportDimensions = () => {
  if (typeof window !== 'undefined') {
    return {
      width: window.innerWidth,
      height: window.innerHeight,
      ratio: window.devicePixelRatio || 1
    };
  }
  return { width: 0, height: 0, ratio: 1 };
};

/**
 * Add mobile detection event listener
 */
export const addMobileDetectionListener = (callback) => {
  if (typeof window !== 'undefined') {
    const handleResize = () => {
      callback({
        isMobile: isMobile(),
        deviceType: getDeviceType(),
        viewport: getViewportDimensions()
      });
    };
    
    window.addEventListener('resize', handleResize);
    
    // Initial call
    handleResize();
    
    // Return cleanup function
    return () => window.removeEventListener('resize', handleResize);
  }
  return () => {};
}; 